import { EModuleType } from '../../Model/EModuleType';
import { Module } from "../../Model/Module";
import { EFetchModuleAction, FetchModuleAction } from "../actions/ModuleActions";
import { FetchStatus } from "./../../Model/FetchStatus";
import { RootState } from "./RootReducer";

type State = {
  status: FetchStatus;
  modules: Module[];
  moduleById: { [index: string]: Module };
  modulesByType: { [index: number]: Module[] };
};

const initialState: State = {
  modules: [],
  moduleById: {},
  modulesByType: {},
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

function processModule(modules: Module[]) {
  let moduleById: { [index: string]: Module } = {};
  let modulesByType: { [index: number]: Module[] } = {};

  for (let module of modules) {
    moduleById[module.identifier] = module;
    if(modulesByType[module.moduleType] == null){
      modulesByType[module.moduleType] = [];
    }
    modulesByType[module.moduleType].push(module);
  }

  return {
    byId: moduleById,
    byType: modulesByType,
  };
}

export function modulesReducer(state = initialState, action: FetchModuleAction): State {
  switch (action.type) {
    case EFetchModuleAction.FETCH_MODULES_PENDING:
      return {
        modules: [],
        moduleById: {},
        modulesByType: {},
        status: {
          pending: true,
          completed: false,
          error: null,
        },
      };
    case EFetchModuleAction.FETCH_MODULES_SUCCESS:
      if (action.modules == null) {
        throw new Error("Modules is null");
      }
      const processed = processModule(action.modules);
      return {
        modules: action.modules,
        moduleById: processed.byId,
        modulesByType: processed.byType,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
      };
    case EFetchModuleAction.FETCH_MODULES_ERROR:
      return {
        modules: [],
        moduleById: {},
        modulesByType: {},
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
      };
    default:
      return state;
  }
}

export const getModule = (state: RootState, moduleIdentifier: string): Module => {
  return state.moduleStore.moduleById[moduleIdentifier];
};

export const getModuleById = (state: RootState,): {[index:string]:Module} => {
  return state.moduleStore.moduleById;
};

export const getModulesByType = (state: RootState,): {[index:number]:Module[]} => {
  return state.moduleStore.modulesByType;
};

export const getModules = (state: RootState, moduleType?: EModuleType): Module[] => {
  if (moduleType == null) {
    return state.moduleStore.modules;
  } else {
    return state.moduleStore.modulesByType[moduleType];
  }
};

export const getModuleFetchStatus = (state: RootState): FetchStatus => state.moduleStore.status;
